<template>
  <div class="cmsdetail">
    <div class="container_wrap">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <template v-for="(item, index) in breadData">
          <el-breadcrumb-item
            :key="index"
            :to="item.url ? item.url : ''"
            v-if="item.name != '首页内容'"
            ><a>{{ item.name }}</a></el-breadcrumb-item
          >
        </template>
        <template v-if="$route.query.cmspositionId">
          <el-breadcrumb-item :to="{path:'/cmsposition',query:{cmspositionId:$route.query.cmspositionId,isfromdetail:1}}"><a>院校动态</a></el-breadcrumb-item>
        </template>
        <el-breadcrumb-item>内容详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="left_and_right_container">
        <div class="container_left">
          <div class="container_left_title">
            {{ itemData.title }}
          </div>
          <div class="container_left_tips">
            <div class="tips_left">
              <div class="tips_left_tag">
                {{ breadData[breadData.length - 1].name }}
              </div>
              <div class="operations_common operations_date">
                <div class="operations_common_icon"></div>
                <div class="operations_common_num">
                  {{ itemData.create_time | yearForm }}年{{
                    itemData.create_time | monthForm
                  }}月{{ itemData.create_time | dayForm }}日
                </div>
              </div>
              <div class="operations_common operations_hotnum">
                <div class="operations_common_icon"></div>
                <div class="operations_common_num">
                  {{ itemData.views_count }}
                </div>
              </div>
            </div>
            <div class="tips_right">
              <!-- <div class="bshare-custom">
                <a title="分享到微信" class="bshare-weixin"></a
                ><a title="分享到复制网址" class="bshare-clipboard"></a>
                <a title="分享到新浪微博" class="bshare-sinaminiblog"></a
                ><a title="分享到豆瓣" class="bshare-douban"></a>
                <a title="分享到QQ空间" class="bshare-qzone"></a
                ><a
                  title="更多平台"
                  class="bshare-more bshare-more-icon more-style-addthis"
                ></a>
                <span class="BSHARE_COUNT bshare-share-count">{{
                  itemData.views_count ? itemData.views_count : 0
                }}</span>
              </div> -->
              <vshare :vshareConfig="vshareConfig"></vshare>
            </div>
          </div>
          <div class="container_left_content">
            <!-- ****************************↑富文本区域*****************  v-html=""-->
            <div class="container_left_text html-data " v-html="itemData.content"></div>
          </div>
        </div>
        <div class="container_right">
          <CmsRecommend></CmsRecommend>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import "http://static.bshare.cn/b/buttonLite.js#style=-1&amp;uuid=&amp;pophcol=1&amp;lang=zh";
// import "http://static.bshare.cn/b/bshareC0.js";
import NewsListItem from "@/components/listItem/NewsListItem";
import CmsRecommend from "@/page/index/cms/CmsRecommend";
export default {
  name: "CmsDetail",
  data() {
    return {
      itemData: [],
      breadData: [{ name: "" }, { name: "" }], //面包屑的内容
      vshareConfig: {
        shareList: ["weixin", "copy", "tsina", "douban", "qzone", "more"],
        common: {
          //此处放置通用设置
          bdText: "",
          bdDesc: "",
          bdUrl: "",
          bdPic: "",
        },
        share: [
          {
            //此处放置分享按钮设置
            bdSize: 20,
          },
        ],
        slide: [
          //此处放置浮窗分享设置
          { bdTop: -1000 },
        ],
        image: [
          //此处放置图片分享设置
        ],
        selectShare: [
          //此处放置划词分享设置
        ],
      },
    };
  },
  beforeCreate() {
    window._bd_share_main = "";
  },
  created() {
    // window.location.reload()
  },
  mounted() {
    this.getitemDetail(this.$route.query.id);
    // this.$nextTick(()=>{
    //   this.dyCreateScript('http://static.bshare.cn/b/buttonLite.js#style=-1&amp;uuid=&amp;pophcol=1&amp;lang=zh')
    //   this.dyCreateScript('http://static.bshare.cn/b/bshareC0.js')
    // })
  },
  components: {
    NewsListItem,
    CmsRecommend,
  },
  methods: {
    dyCreateScript(url) {
      // 创建script标签，执行script内容
      let script = document.createElement("script");
      script.type = "text/javascript";
      script.src = url;
      document.getElementsByTagName("head")[0].appendChild(script);
    },
    //获取面包屑的内容
    getStoreBread(cate_id) {
      var that = this;
      that.$api.get(
        "/api/cms/breadList",
        {
          cate_id: cate_id,
        },
        (res) => {
          // this.$message.success("发送成功");
          that.breadData = res.data;
          that.breadData.some((item) => {
            if (item.url) {
              item.url = eval("(" + item.url + ")");
            }
          });
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
    searchFun() {
      this.$message({ type: "success", message: "search" });
    },
    getitemDetail(id) {
      var that = this;
      that.$api.get(
        "/api/cms/detail",
        {
          id: id,
        },
        (res) => {
          // this.$message.success("发送成功");
          // console.log("resres.....",res)
          that.itemData = res.data.data;
          if(typeof this.itemData.extra_data[0].value !='undefined' && this.itemData.extra_data[0].value.indexOf('http') > -1){
            this.$router.go(-1)
            window.open(this.itemData.extra_data[0].value,'_blank')
          }
          that.vshareConfig.common.bdText = res.data.share_data.title;
          that.vshareConfig.common.bdDesc = res.data.share_data.desc;
          that.vshareConfig.common.bdUrl = res.data.share_data.url;
          that.vshareConfig.common.bdPic = res.data.share_data.pic_url;
          // console.log(that.vshareConfig.common)
          //通知公告
          that.getStoreBread(that.itemData.cate_ids[0]);
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
  },
  watch: {
    $route: {
      handler() {
        if (this.$route.name == "CmsDetail") {
          this.getitemDetail(this.$route.query.id);
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped lang="scss">
.cmsdetail {
  width: 100%;
  background: #f4faff;
  height: 100%;
  overflow: hidden;
}
.container_wrap {
  width: 1240px;
  margin: 0 auto;
  min-height: 1235px;
}
.breadcrumb {
  margin-top: 21px;
  margin-left: 23px;
  margin: 21px 0 20px 23px;
}
.left_and_right_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 20px;
  .container_left {
    width: 910px;
    padding-left: 23px;
    box-sizing: border-box;
    padding-top: 26px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius:34px;
    padding-right: 45px;
    .container_left_title {
      margin-left: 7px;
      width: 801px;
      font-size: 30px;
      
      font-weight: 400;
      color: #000000;
      line-height: 42px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .container_left_tips {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-top: 16px;
      .tips_left {
        display: flex;
        flex-direction: row;
        .tips_left_tag {
          width: 70px;
          height: 22px;
          background: rgba(50, 197, 255, 0.7);
          border-radius: 10px 10px 10px 0px;
          text-align: center;
          line-height: 22px;
          font-size: 12px;
          
          font-weight: 400;
          color: #ffffff;
        }
        .operations_common {
          display: flex;
          flex-direction: row;
          height: 20px;
          font-size: 12px;
          
          font-weight: 400;
          color: #999999;
          line-height: 20px;
          .operations_common_icon {
            display: inline-block;
            margin-right: 4px;
            margin-top: 2px;
            width: 19px;
            height: 16px;
            background: url("~@/assets/images/listitem/icon-news-list-time@2x.png")
              no-repeat;
            background-size: 100% 100%;
          }
        }
        .operations_date {
          margin-left: 25px;
        }
        .operations_hotnum {
          margin-left: 29px;
          .operations_common_icon {
            width: 13px;
            height: 16px;
            background: url("~@/assets/images/listitem/icon-news-list-hot@2x.png")
              no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
    .container_left_content {
      margin-top: 24px;
      /deep/.container_left_text {
        // p {
        //   font-size: 14px !important;
        //   line-height: 20px;
        // }
      }
    }
  }
  .container_right {
    width: 306px;
  }
}
</style>


// WEBPACK FOOTER //
// CmsDetail.vue?c885b80c